import type { PivotLayout, PivotLayoutFilter } from '@ztechapps/common.contract'
import type { PivotData } from './types'
import { PivotFieldTypeEnum } from '@ztechapps/common.contract'
import { describePivotCondition, describePivotValueComparison } from '@ztechapps/common.utils'
import { toPivotFieldLabel } from './toPivotFieldLabel'

/** A Condition or Value comparison in the filter bar — its filters entry, its field label and its wording. */
export type PivotConditionChip = { filter: PivotLayoutFilter; label: string; text: string }

/** Lists the filters entries holding a Condition or a Value comparison, each with its field label and wording. */
export const listPivotConditionChips = ({
  data,
  layout,
}: {
  data: PivotData
  layout: Pick<PivotLayout, 'filters'>
}): PivotConditionChip[] =>
  layout.filters.flatMap((filter) => {
    const { conditionFilter, valueComparison } = filter
    const pivotField = data.fields.find((item) => item.name === filter.field)
    const text = conditionFilter
      ? describePivotCondition(conditionFilter, pivotField?.type ?? PivotFieldTypeEnum.String)
      : valueComparison && describePivotValueComparison(valueComparison)
    if (!pivotField || !text) return []
    return [{ filter, label: toPivotFieldLabel(pivotField, filter.field, filter.dateGroup), text }]
  })
